import React, { useState, useEffect, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
const DropdownMenu = ({ isOpen, onClose, buttonRef, children }) => {
  const dropdownRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!isOpen || !buttonRef.current) return;

    const updatePosition = () => {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 192; // w-48 = 12rem = 192px

      let top = rect.bottom + 8;
      let left = rect.right - dropdownWidth;

      // 화면 밖으로 나가는지 체크
      if (left < 0) left = rect.left;
      if (top + 200 > window.innerHeight) {
        top = rect.top - 200 - 8;
      }

      setPosition({ top, left });
    };

    updatePosition();
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);

    const handleClickOutside = (e) => {
      if (
        !dropdownRef.current?.contains(e.target) &&
        !buttonRef.current?.contains(e.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, buttonRef, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      ref={dropdownRef}
      className="fixed w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200"
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      <div className="py-1">{children}</div>
    </div>,
    document.body
  );
};

export default DropdownMenu;
